import { Component, OnInit, Input, TemplateRef, Output, EventEmitter } from '@angular/core';
import { EditPropertyDeatilsModel, PropertySaleHistoryModel, BrokerSelecttionModel, PropertyDocument, PropertySalesInputModel } from '../../../../../shared/models/SavePropertyInputModel';
import { IFileUpload, IPropertyFileUpload } from '../../../../../shared/models/fileupload';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PropertyManagementService } from '../../../../../shared/providers/property-management.service';
import { ValidationService } from '../../../../../shared/providers/validation.service';
import { FileUploadService } from '../../../../../shared/providers/fileupload.service';
import { Observable } from 'rxjs';
import { LoaderService } from '../../../../../shared/providers/loader.service';
import { ToastService } from '../../../../../shared/providers/toast.service';
import { AuthenticationService } from '../../../../../shared/auth/authentication.service';
import { SharedService } from '../../../../../shared/providers/shared.service';
import { CommonService } from '../../../../../shared/providers/common.service';

@Component({
  selector: 'app-my-portfolio-sale-history-list',
  templateUrl: './my-portfolio-sale-history-list.component.html',
  styleUrls: ['./my-portfolio-sale-history-list.component.css']
})
export class MyPortfolioSaleHistoryListComponent implements OnInit {
  @Input() propertyId: number;
  @Input() IsPDeleted: boolean = false;
  @Input() IsDataEntryPrperty: boolean = false;
  @Input() propertyModel: any;
  @Input() isFromPropertyTab = false;
  @Input() canEditHistory: boolean;
  @Output() saveSaleHistory = new EventEmitter();
  salesHistory = {} as PropertySalesInputModel;
  lstSalesHistory = [] as PropertySalesInputModel[];
  uploadedFiles: IPropertyFileUpload[] = [];
  fileUploadCount = 0;
  revisionId = 0;
  documentId = 0;
  editIndex: number;
  modalRef: BsModalRef;
  FileUpload = {} as IFileUpload;
  showAddSaleHistory: boolean = false;
  user: any;
  property: any;
  @Input() transactionTypeId: number = 6500;
  IsFromAddEditPage = false as boolean;
  SalesHistoryAdd = false as boolean;
  @Output() disableAddEditHistoryButton = new EventEmitter();
  capratetext: string;

  constructor(private modalService: BsModalService,
    private _propertyManagementService: PropertyManagementService,
    public _validationService: ValidationService,
    private _fileUploadService: FileUploadService,
    private _loaderService: LoaderService,
    private _toastService: ToastService,
    public authService: AuthenticationService,
    private _sharedService: SharedService
  ) { }

  ngOnInit() {

    this.user = this.authService.user != null ? this.authService.user : '';
    if (this.user != '')

     {
      this.showAddSaleHistory = true;
    }

    if (this.propertyId != null && this.propertyId > 0) {
      this._loaderService.display(true);
      this.getLeasingHistory();
    }

    if (this.propertyModel != null) {
      this.property = Object.assign({}, this.propertyModel);
      this.IsFromAddEditPage = true;
    }
    else {
      if (this.IsDataEntryPrperty) {
        this._propertyManagementService.GetDataEntryPropertyDetailsForSaleHistory(this.propertyId).subscribe(res => {
          this.property = res;

        });
      }
      else {
        this._propertyManagementService.GetPropertyDetailsForSaleHistory(this.propertyId).subscribe(res => {
          this.property = res;
        });
      }
    }
  }

  openSalesHistoryAdd(template: TemplateRef<any>, id, classes) {

    this.SalesHistoryAdd = true;
    this.transactionTypeId = id;
    const config = {
      ignoreBackdropClick: true,
      class: classes,
      keyboard: false,
      backdrop: true
    }


    this._sharedService.propertyRentTermTable.subscribe(res => {
      if (this.SalesHistoryAdd) {
        if (this.IsFromAddEditPage) {
          this.salesHistory.SaleHistoryRentTerm = Object.assign([], res);
        }
        else {
          this.salesHistory.SaleHistoryRentTerm = Object.assign([], this.property.PropertyRentTerm);
        }
        this.SalesHistoryAdd = false;
      }
    });

    if (this.propertyModel != null) {
      this.property = Object.assign({}, this.propertyModel);
    }

    if (this.property != null) {
      this._propertyManagementService.GetSaleInfoFromOffers(this.property.Guid).subscribe(res => {
        if (Number(this.property["PropertyId"]) != 0) {
          if (res["SaleDate"] != null) {
            this.salesHistory.SaleDate = this._validationService.convertUTCDateToLocalDate(res["SaleDate"]);
          }
          this.salesHistory.SalePSF = res["SalePrice"] != null ? Number(res["SalePrice"]) / Number(this.property.BuildingSize) : 0;
          this.salesHistory.SaleCapRate = res["SalePrice"] != null ? (Number(this.property.NOI) / Number(res["SalePrice"])) * 100 : 0;
          this.salesHistory.SalePrice = res["SalePrice"];
          this.salesHistory.AutoPopulated = true;
        }
        this.salesHistory.DateOnMarket = this.property.CreatedDate == undefined ? new Date : this._validationService.convertUTCDateToLocalDate(this.property.CreatedDate);
        this.salesHistory.IsAdd = true;
        this.salesHistory.NOI = this.property.NOI;
        this.salesHistory.BuildingSize = this.property.BuildingSize;
        this.salesHistory.AskingPrice = this.property.Price;
        this.salesHistory.AskingCapRate = this.property.CapRate;
        this.modalRef = this.modalService.show(template, config);
      });

    }
  }

  getValue(filter, item: any) {
    var val = item.PropertyRevisionFieldModels.filter(i => i.Name == filter)[0];
    if (val != undefined && val != null) {
          return item.PropertyRevisionFieldModels.filter(i => i.Name == filter)[0].NewValue;
    }

    return null;
  }

  openSalesHistoryEdit(template: TemplateRef<any>, classes, item, i) {
    const config = {
      ignoreBackdropClick: true,
      class: classes,
      keyboard: false,
      backdrop: true
    }

    this.editIndex = i;
    this.salesHistory = Object.assign({}, this.lstSalesHistory[this.editIndex]);
    this.salesHistory.IsAdd = false;
    this.salesHistory.NOI = this.property.NOI;
    this.salesHistory.BuildingSize = this.property.BuildingSize;
    this.revisionId = item.RevisionId;
    this.modalRef = this.modalService.show(template, config);
  }

  onRemoveDocument() {

    this._loaderService.display(true);
    this._propertyManagementService.deleteDocument(this.documentId, this.user.Id).subscribe(response => {
      if (response) {
        this.getLeasingHistory();
        this.documentId = 0;
        this._loaderService.display(false);

        this._toastService.addToast({
          title: 'Success',
          msg: 'Document deleted!',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
      }
    });


  }

  openSalesHistoryDelete(template: TemplateRef<any>, classes, item, i) {
    this.revisionId = item.RevisionId;
    this.modalRef = this.modalService.show(template);
  }

  openDocumentDelete(template: TemplateRef<any>, classes, id, i) {
    this.documentId = id;
    this.modalRef = this.modalService.show(template);
  }

  onHistoryDelete() {
    this._propertyManagementService.DeleteHistory(this.revisionId).subscribe(res => {
      this._toastService.addToast({ title: 'Success', msg: 'History Delete Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });

      this.reloadView();
      this.modalRef.hide();
    });
  }

  closeModal() {
    //this.salesHistory.SaleHistoryRentTerm.forEach(item => item.IsEditModeOn = false);
    this.disableAddEditHistoryButton.emit(false);
    this.modalRef.hide();
    this.revisionId = 0;
    //this.reloadView();
  }

  toggle_child(data, type, index) {
    this.lstSalesHistory.map(item => {
      if (data === item) {
        if (type == 1) // doc
        {
          item.ShowDoc = !item.ShowDoc
        }
        else if (type == 2) // rent term
        {
          item.ShowRentTerm = !item.ShowRentTerm

        }
        else if (type == 3) // rent term
        {
          item.ShowProp = !item.ShowProp

        }
        else {
          this.SetHistoryIndex(this.propertyId, index);
          item.showChild = !item.showChild;
        }

      }
      else {
        if (type == 1) // doc
        {
          item.ShowDoc = false;
        }
        else if (type == 2) // rent term
        {
          item.ShowRentTerm = false

        }
        else {
          item.showChild = false;
        }
      }
    })
  }

  saveSaleHistoryDoc(saleDetails, res, objectTypeId) {
    this.FileUpload.fileCategoryId = 0;
    this.FileUpload.id = res.Id;
    this.FileUpload.objectId = res.Id;
    this.FileUpload.objectTypeId = objectTypeId;
    this.FileUpload.type = "Documents";

    if (saleDetails.RemovedDocuments != null && saleDetails.RemovedDocuments.length > 0) {
      this._propertyManagementService.deleteMultipleDocument(saleDetails.RemovedDocuments, this.user.Id).subscribe(res => {
        this.closeModal();
        this.reloadView()
      });
    }

    if (saleDetails.SelectedFiles != null && saleDetails.SelectedFiles != undefined && saleDetails.SelectedFiles.length > 0) {
      let index = 0;
      saleDetails.SelectedFiles.forEach(item => {
        this.FileUpload.documentName = item.name;
        var data = [];
        data.push(item);
        this._fileUploadService.uploadFiles(this.FileUpload, data).subscribe(response => {
          index++
          if (index == saleDetails.SelectedFiles.length) {
            this.closeModal();
            this.reloadView()
            this._toastService.addToast({ title: 'Success', msg: 'Sale History Saved Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          }
        });
      });
    }
    else {
      this.closeModal();
      this.reloadView()
      this._toastService.addToast({ title: 'Success', msg: 'Sale History Saved Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
    }
  }

  reloadView() {
    this.lstSalesHistory = [];
    this.getLeasingHistory();
  }

  getLeasingHistory() {
    let index = 0;
    this.IsDataEntryPrperty = this.IsDataEntryPrperty == undefined ? false : this.IsDataEntryPrperty;
    this._propertyManagementService.GetPropertySaleHistory(this.propertyId, this.transactionTypeId, this.IsDataEntryPrperty, 6857).subscribe(res => {
      index = this.getHistoryIndex(this.propertyId);
      if (res && res.length > 0) {
        for (let i = 0; i < res.length; i++) {
          if (i == index) {
            res[i].showChild = true;
          }

          //res[i].DateOnMarket = this._validationService.convertUTCDateToLocalDate(res[i].DateOnMarket);
          res[i].EntryDate = this._validationService.convertUTCDateToLocalDate(res[i].EntryDate);

          if (res[i].Properties.length > 0) {
            res[i].Properties.forEach(x => {
              if (x.CharacteristicsId != 0) {
                x.capratetext = 'ZCF';
              }
              else {
                x.capratetext = 'Cap Rate';
              }
            })
          }
        }
        this.lstSalesHistory = res;
        console.log(res);
      }
      this._loaderService.display(false);
    })
  }

  downloaddoc(item) {
    if (item.length > 0) {
      item.forEach(x => {
        window.open(x.Url, '_blank');

      })
    }
  }

  saveSalesDetails(e) {
    //if (!this.isFromPropertyTab)
    this.reloadView();
  }

  SetHistoryIndex(propertyId, index) {
    let storageValue = localStorage.getItem("historydetails")
    let jsonValue = [] as any;
    let haveValue = false;
    let userId = this.user.Id
    let propertyType = this.IsDataEntryPrperty ? 2 : 1;
    let historyType = 1 // sale history 
    let data = {
      HistoryType: null, // 2 = lease history or  1 = sale history
      PropertyType: null, // 1 = property or 2 = data entry staff
      PropertyId: null,
      Index: null,
      UserId: null
    }

    if (storageValue != null && storageValue != undefined) {
      jsonValue = JSON.parse(storageValue)
      haveValue = jsonValue.filter(x => x.HistoryType == historyType && x.PropertyType == propertyType && x.UserId == userId && x.PropertyId == propertyId).length > 0 ? true : false;
      if (haveValue) {
        jsonValue.forEach(x => {
          if (x.HistoryType == historyType && x.PropertyType == propertyType && x.UserId == userId && x.PropertyId == propertyId) {
            x.Index = index
          }
        })
      }
      else {
        data.HistoryType = historyType;
        data.PropertyType = propertyType;
        data.PropertyId = propertyId;
        data.Index = index;
        data.UserId = userId;
        jsonValue.push(data);
      }
      localStorage.setItem("historydetails", JSON.stringify(jsonValue));
    }
    else {
      data.HistoryType = historyType;
      data.PropertyType = propertyType;
      data.PropertyId = propertyId;
      data.Index = index;
      data.UserId = userId;
      jsonValue.push(data);
      localStorage.setItem("historydetails", JSON.stringify(jsonValue));
    }
  }

  getHistoryIndex(propertyId) {

    let storageValue = localStorage.getItem("historydetails")
    let jsonValue = [] as any;
    let haveValue = false;
    let index = 0; // default index
    let userId = this.user.Id
    let propertyType = this.IsDataEntryPrperty ? 2 : 1;
    let historyType = 1 // sale history 

    if (storageValue != null && storageValue != undefined) {
      jsonValue = JSON.parse(storageValue)
      haveValue = jsonValue.filter(x => x.HistoryType == historyType && x.PropertyType == propertyType && x.UserId == userId && x.PropertyId == propertyId).length > 0 ? true : false;
      if (haveValue) {
        jsonValue.forEach(x => {
          if (x.HistoryType == historyType && x.PropertyType == propertyType && x.UserId == userId && x.PropertyId == propertyId) {
            index = x.Index;
          }
        })
      }
    }

    return index;
  }
}
